module.exports = __webpack_public_path__ + "static/media/29BDOS13.e1eb6a7d.jpg";